import { IconType } from "react-icons/lib";

import { DocType } from "@megaron/docs-contracts";

import { fallbackAccentColor, fallbackDocIcon, historyDocRouteByType } from "./docRoutes";

export const docHref = (docType: DocType, docId: string): string | undefined => {
  const route = historyDocRouteByType.get(docType);
  if (!route) return undefined;

  const identifier = docId.slice(docType.length + 1);
  if (!identifier) return undefined;

  return route.buildPath(identifier);
};

export const docTypeIcon = (docType: DocType): IconType =>
  historyDocRouteByType.get(docType)?.Icon ?? fallbackDocIcon;

export const docTypeLabel = (docType: DocType): string => historyDocRouteByType.get(docType)?.label ?? "";

export const docAppLabel = (docType: DocType): string => historyDocRouteByType.get(docType)?.appLabel ?? "";

export const docTypeAccentColor = (docType: DocType): string =>
  historyDocRouteByType.get(docType)?.accentColor ?? fallbackAccentColor;
